export function getBrowserLocale() {
  return window.navigator.language;
}
